import { atomWithStorage } from 'jotai/utils';
import { DataVersionOverride } from '@hakimo-ui/hakimo/types';

/**
 * Which dataset the internal v2/v3 read surfaces use. Defaults to `v2`
 * (legacy), and is persisted, so a choice survives reloads.
 *
 * There is deliberately no UI for this. It is set by hand while the
 * cloud-unification rollout is being validated:
 *
 *   localStorage.setItem('locationAlarms/dataVersionOverride', '"v3"')
 *
 * (the stored value is JSON, so the quotes are required), then reload. Set it
 * back to `'"v2"'` to return to legacy reads. A control for it can be added
 * over this atom without touching anything downstream.
 *
 * Read it through `useApiDataVersion()` when the value is destined for a
 * request — that hook applies the "only send v3" rule. Reading it raw suits
 * non-request uses, such as resetting dataset-specific UI state when it flips.
 */
export const dataVersionOverrideAtom = atomWithStorage<DataVersionOverride>(
  'locationAlarms/dataVersionOverride',
  'v2',
  undefined,
  { getOnInit: true }
);
